"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridStyleName = exports.DataGridColors = void 0;
var widgets_1 = require("@tableau/widgets");
var TypeStyle = require("typestyle");
var Colors = widgets_1.TabStyles.Colors;
exports.DataGridColors = {
    Selected: "var(--data-grid-selected-background-color, #cde7f8)",
    // Hover: Colors.F3,
    AltRow: "var(--data-grid-row-banding-background-color, " + Colors.F2 + ")",
    HeaderBorder: "var(--data-grid-header-border-color, " + Colors.L5 + ")",
    HorizontalGridLine: "var(--data-grid-horizontal-line-color, " + Colors.L2_5 + ")",
    SelectedGridLine: "var(--data-grid-selected-line-color, white)",
    VerticalGridLine: "var(--data-grid-vertical-line-color, " + Colors.L4 + ")",
};
exports.DataGridStyleName = TypeStyle.style({
    // DefaultScrollComponent is absolutely positioned so the grid element needs to be the relative parent
    position: 'relative',
    overflow: 'hidden',
    height: '100%',
    $nest: {
        '&:focus': {
            outline: 'none',
        },
        '& [role="gridcell"]:focus, & [role="columnheader"]:focus': {
            outline: 'none',
        },
        '&.focus-visible [role="gridcell"]:focus, &.focus-visible [role="columnheader"]:focus': {
            boxShadow: "inset 0 0 0 1px " + Colors.Focus,
        }
    }
});
//# sourceMappingURL=DataGridColors.js.map